export default __webpack_public_path__ + "static/media/privilege-ticket-yellow.7c1bb86f.svg";